<script>
import { mapGetters } from 'vuex';
import SimplePlaceholder from '../kit/SimplePlaceholder.vue';

export default {
  name: 'ProductList',
  computed: {
    ...mapGetters({
      products: 'search/products',
      pagination: 'search/pagination',
    }),
    isLoading() {
      return !this.products;
    },
  },
  components: { SimplePlaceholder },
};
</script>

<template>
  <div class="pl-2 md:pl-0 break-normal text-gray-900 text-base md:text-lg">
    <SimplePlaceholder v-if="isLoading" />
    <span class="text-gray-900 font-bold text-xl" v-else>
      {{ $tc('products_title', pagination.total_count) }}
    </span>
  </div>
</template>
